import { render } from "./Loading.vue?vue&type=template&id=3373d274&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=3373d274&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-3373d274"

export default script